import React from 'react';
import {observer} from 'mobx-react-lite';
import UserPreferencesSection from '../../components/UserPreferencesSection';

const ProfilePreferencesPage: React.FC = () => (
    <UserPreferencesSection/>
);

export default observer(ProfilePreferencesPage);
